export default function NavigationBar() {
  return (
    <>
    </>
  )
}